import { lazy } from 'react';

export const DayBookreportLazy = lazy(
  () => import('@/pages/reports/pages/DayBooksReport'),
);
export const DayStockLedgerReportLazy = lazy(
  () => import('@/pages/reports/pages/day-stock-ledger-report'),
);
export const StockBookReportLazy = lazy(
  () => import('@/pages/reports/pages/stock-book-report'),
);
export const ExpenseReportLazy = lazy(
  () => import('@/pages/reports/pages/expense-report'),
);
export const ExpenseDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/expense-detail-report'),
);
export const GoldRateHistoryLazy = lazy(
  () => import('@/pages/reports/pages/GoldRateHistory'),
);
export const IssueDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/IssueDetailsReport'),
);
export const KarigarIssueDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/KarigarIssueDetailsReport'),
);
export const KarigarReceiveDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/KarigarReceiveDetailsReport'),
);
export const KarigarReceiveReportLazy = lazy(
  () => import('@/pages/reports/pages/KarigarReceiveReport'),
);
export const KarigarReportLazy = lazy(
  () => import('@/pages/reports/pages/KarigarReport'),
);
export const LedgerDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/LedgerDetailsReport'),
);
export const LedgerReportLazy = lazy(
  () => import('@/pages/reports/pages/LedgerReport'),
);
export const AdvanceLazy = lazy(
  () => import('@/pages/reports/pages/AdvanceReport'),
);
export const SalesHistoryReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesHistoryReport'),
);
export const SalesItemWiseReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesItemWiseReport'),
);
export const OpeningStockDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/OpeningStockDetailReport'),
);

export const IrdAnnex5ReportLazy = lazy(
  () => import('@/pages/reports/pages/ird-annex-5-report'),
);
export const PendingIrdReport = lazy(
  () => import('@/pages/reports/pages/PendingIrdReport.tsx'),
);

export const OrderDetailreportLazy = lazy(
  () => import('@/pages/reports/pages/OrderDetailReport'),
);
export const OrderReportLazy = lazy(
  () => import('@/pages/reports/pages/OrderReport'),
);
export const OrderTrackingReportLazy = lazy(
  () => import('@/pages/reports/pages/OrderTrackingReport'),
);
export const PartyIssueDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/PartyIssueDetailReport'),
);
export const PartyReceiveDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/PartyReceiveDetailReport'),
);
export const PartyReceiveReportLazy = lazy(
  () => import('@/pages/reports/pages/PartyReceiveReport'),
);
export const PurchaseDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/PurchaseDetailReport'),
);
export const PurchaseReportLazy = lazy(
  () => import('@/pages/reports/pages/PurchaseReport'),
);
export const RefineIssueDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/RefineIssueDetailReport'),
);
export const RefineProfitLossReportLazy = lazy(
  () => import('@/pages/reports/pages/RefineProfitLossReport'),
);
export const RefineReceiveDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/RefineReceiveDetailReport'),
);
export const RefineReceiveReportLazy = lazy(
  () => import('@/pages/reports/pages/RefineReceiveReport'),
);
export const SalesDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesDetailsReport'),
);
export const SalesRegisterReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesRegisterReport'),
);
export const SalesReturnReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesReturnReport'),
);
export const SalesReturnDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesReturnDetailsReport'),
);
export const PurchaseReturnReportLazy = lazy(
  () => import('@/pages/reports/pages/PurchaseReturnReport'),
);
export const PurchaseReturnDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/PurchaseReturnDetailsReport'),
);
export const SalesReturnRegisterReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesReturnRegisterReport'),
);
export const SalesBillSummaryLazy = lazy(
  () => import('@/pages/reports/pages/SalesBillSummary'),
);
export const SalesReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesReport'),
);
export const StockDetailReportLazy = lazy(
  () => import('@/pages/reports/pages/StockDetailReport'),
);
export const StockLedgerReportLazy = lazy(
  () => import('@/pages/reports/pages/StockLedgerReport'),
);
export const StockReceiptDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/StockReceiptDetailsReport'),
);
export const StockReceiptReportLazy = lazy(
  () => import('@/pages/reports/pages/StockReceiptReport'),
);
export const StockReportLazy = lazy(
  () => import('@/pages/reports/pages/StockReport'),
);
export const StockValuationReportLazy = lazy(
  () => import('@/pages/reports/pages/StockValuationReport'),
);
export const SundryCreditorsReportLazy = lazy(
  () => import('@/pages/reports/pages/SundryCreditorsReport'),
);
export const SundryDeptorsReportLazy = lazy(
  () => import('@/pages/reports/pages/SundryDeptorsReport'),
);
export const VoucherDetailsReportLazy = lazy(
  () => import('@/pages/reports/pages/VoucherDetailsReport'),
);
export const VoucherReportLazy = lazy(
  () => import('@/pages/reports/pages/VoucherReport'),
);
export const ReportsLazy = lazy(() => import('@/pages/reports/Reports'));
export const OrderStatusLazy = lazy(
  () => import('@/pages/reports/pages/OrderStatusReport'),
);
export const SalesRateChangeHistoryLazy = lazy(
  () => import('@/pages/reports/pages/SalesRateChangeHistory'),
);

export const TrayNameChangeHistoryLazy = lazy(
  () => import('@/pages/reports/pages/tray-name-change-history-report'),
);

export const CustomerLedgerReportLazy = lazy(
  () => import('@/pages/reports/pages/CustomerLedgerReport'),
);
export const LoanStockReportLazy = lazy(
  () => import('@/pages/reports/pages/LoanStockReport'),
);
export const LoanStockInBankReportLazy = lazy(
  () => import('@/pages/reports/pages/LoanStockInBankReport'),
);
export const LoanBankWiseStockReportLazy = lazy(
  () => import('@/pages/reports/pages/LoanBankWiseStockReport'),
);
export const LoanDealTrackingReportLazy = lazy(
  () => import('@/pages/reports/pages/LoanDealTrackingReport'),
);
export const KarigarLedgerReportLazy = lazy(
  () => import('@/pages/reports/pages/KarigarLedgerReport'),
);

export const CashBankReportLazy = lazy(
  () => import('@/pages/reports/pages/CashBankReport'),
);

export const SalesGrossProfitReportLazy = lazy(
  () => import('@/pages/reports/pages/SalesGrossProfitReport'),
);
